/* eslint-disable quote-props */
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Location } from "@angular/common";
import { Component, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { LoggingService, NotificationService } from "@core/services";
import { LookupListService } from "@modules/common/services/lookup-list.service";
import { NgbDate, NgbDateStruct, NgbModal, NgbModalRef, NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import {
  AttachmentType,
  BaseAttachmentDto,
  codeOnly, CustomerMasterDto, fullName, generateCheckDigit, GeoPosToGpsCoordinates, JobDto, JobHoldDto, JobHoldTypeDto, JobHoldTypes, JobJournalDto, JobLineDto,
  JobStatusDto, JobTypeDto, JobVat, JobVisitDto, LookupListEx, LookupObjectDto,
  MachineJobDto, MenuItem, ModelMasterDto, newCustomerContact, newJobLine, ResourceMasterDto, trim
} from "@shared/models";
import { JobEdiDto } from "@shared/models/jobs/JobEdiDto";
import { formatFollowUpDate, JobFollowUpDto } from "@shared/models/jobs/JobFollowUpDto";
import { JobMessageDto } from "@shared/models/jobs/JobMessageDto";
import { forkJoin, Observable, of } from "rxjs";
import { catchError, distinctUntilChanged, filter, map, switchMap, take, tap } from "rxjs/operators";
import { FieldSettings } from "@shared/models/FieldSettings";
import { ChecklistEntryDto } from "@shared/models/checklist/ChecklistDto";
import { NgSignaturePadOptions, SignaturePadComponent } from "@almothafar/angular-signature-pad";
import { checkUntilExists, convertToDate, convertToNgbDate, dateSort, PublishSubscribe } from "../../common";
import { AppQuery, LoginStatus } from "../../common/app.store";
import { AddressComponent, AttachmentGalleryData, BaseFormDirective, ButtonType, ContactComponent, CustomDialogComponent, FileCapture, MachineMasterComponent } from "../../common/components";
import { ChecklistService, CodeListName, CustomerService, JobService, KeyGetter, KeyboardShortcutService, KeyboardShortcuts, MachineService, ModelService, ProductSettingService, ResourceService, SnackBarBaseService, SnackBarService, WebLayoutService } from "../../common/services";
import { ScheduleJobComponent } from "../schedule-job/schedule-job.component";
import { ChecklistComponent } from "../checklist/checklist.component";
import { GPSTrackingFieldComponent } from "./gps-tracking-field/gps-tracking-field.component";

export const HoldPermission = {
  SIGNATURE: 'SignOnGlass'
}
interface JobForm extends JobDto {
  codes: {
    diagnosticCodeId: string;
    componentCodeId: string;
    repairCodeId: string;
    statusId: string;
    faultCodeId: string;
    typeId: string;
    field1: string;
    field2: string;
    field3: string;
    field4: string;
    field5: string;
    purchaseOrderNumber: string;
    customerRef: string;
    ourRef: string;
  }
}

interface StatusButton {
  label: string;
  statuses: string[];
  getStatus?: () => Promise<string>;
  colour: string;
  blockVisited?: boolean;
  visibleCheck?: () => boolean;
  labelTicked?: string;
  confirmAction?: () => Promise<boolean>;
}
@Component({
  selector: "abi-job-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"]
})
export class DetailsComponent extends BaseFormDirective implements OnInit, OnDestroy {
  @ViewChild("signatureDialogBody") signatureDialogBody;
  @ViewChild("editReasonBody") editReasonBody;
  @ViewChild(ChecklistComponent) checklistRef: ChecklistComponent;
  HoldPermission = HoldPermission;
  canPublicUpload = false;
  jobAtBranch = false;
  isPublic = false;
  generateCheckDigit = generateCheckDigit;
  activeTab = "summary";
  googleMapUri = "";
  userCanEdit = false;
  hiddenTabs: string[];
  extraMenu: MenuItem[] = [];
  extraLabel: string;
  showExtraButton = false;
  readonly minDate = convertToNgbDate(Date.today());
  public holdTypes: LookupListEx<JobHoldTypeDto> = new LookupListEx([]);
  emptyNumberKey = "Job.ClickToAdd";
  emptyNumber = "";
  private jobClosed = false;
  private jobOpened = false;

  jobStatuses: LookupListEx<JobStatusDto>;
  jobTypes: LookupListEx<JobTypeDto>;
  canChangeFrom = false;
  checkStatusRoles = false;
  canSeeContract = false;
  isAdmin = false;
  isFinance = false;
  isMan = false;
  isTech = false;
  showDelivered = false;
  showPartOrdered = false;
  showAddHold = true; //
  extraStatus = "";
  codJob = false;
  showValidation = false;
  tenant: string;
  loanUnitCount = 0;
  showJobErrors = true;
  loading = false;
  JobHoldTypes = JobHoldTypes;
  validationMessages = {
    /*
          faultDescription: ["", ],
          noteInternal: ["", Validators.minLength(this.productSettings.numericValue("JobNoteInternalLength"))],
          noteExternal: ["", Validators.minLength(this.productSettings.numericValue("JobNoteExternalLength"))],
    */
    text: {
      // "required": "At least 20 characters required.",
      minlength: "Job.MinLength"
    },
    consent: {
      required: "Job.ConsentRequired"
    },
    faultDescription: {
      minlength: (c: AbstractControl) =>
        this.requiredChars(c, "JobFaultDescriptionLength"),
      required: (c: AbstractControl) =>
        this.requiredChars(c, "JobFaultDescriptionLength")
    },
    noteInternal: {
      minlength: (c: AbstractControl) =>
        this.requiredChars(c, "JobNoteInternalLength"),
      required: (c: AbstractControl) =>
        this.requiredChars(c, "JobNoteInternalLength")
    },
    noteExternal: {
      minlength: (c: AbstractControl) =>
        this.requiredChars(c, "JobNoteExternalLength"),
      required: (c: AbstractControl) =>
        this.requiredChars(c, "JobNoteInternalLength")
    },
    ...MachineMasterComponent.validationMessages,
    gpscoordinates: {
      ...GPSTrackingFieldComponent.validationMessages
    }
  };

  filterCloseCodes: (item: LookupObjectDto, text: string) => boolean = null;
  filterComponentCodes: (item: LookupObjectDto, text: string) => boolean = null;
  filterDiagnosticCodes: (item: LookupObjectDto, text: string) => boolean = null;
  filterFaultCodes: (item: LookupObjectDto, text: string) => boolean = null;

  buttons1: StatusButton[] = [
    { label: "Job.IncorrectDetails", statuses: ["LOGNO"], colour: "danger" },
    { label: "Job.IncorrectDetails", statuses: ["LOGERR"], colour: "danger" },
    { label: "Job.IncorrectTechnician", statuses: ["LOGTECH"], colour: "danger" },
    {
      label: "Job.EscalateToManagement",
      statuses: ["ESCMANAGE"],
      colour: "warning",
      labelTicked: "Job.EscalatedToManagement"
    },
  ];

  openStatusChangeConfirmationDialog(statusToChangeTo: string, descriptionText: string): Promise<string> {
    // check if status is active (lookup)
    const item = this.jobStatuses.item(statusToChangeTo);
    if(item?.active) {
      return this.getModalResponse(item, descriptionText);
    } else {
      return this.getModalResponse(null, descriptionText);
    }
  }

  getModalResponse(changeToStatus: JobStatusDto, bodyDescription: string) {
    const dialogRef = this.modal.open(CustomDialogComponent);
    const instance = dialogRef.componentInstance as CustomDialogComponent;
    instance.buttons = [{
        label: "Close",
        class: "btn btn-light",
        action: (modeRef) => {modeRef.close(false)}
    }]
    if(changeToStatus)
      instance.buttons.push({
        label: `or Change Status to "${changeToStatus.label}"`,
        class: "btn btn-primary",
        action: (modRef) => {modRef.close(true)}
    })
    instance.body = bodyDescription;
    instance.title = "Attention";
    return new Promise<string>((resolve, reject) => {
      dialogRef.closed.subscribe((result) => {
        if(result) {
          // confirm change status
          resolve(changeToStatus.code);
        } else {
          // Leave
          resolve("");
        }
      });
    });
  }

  buttons2: StatusButton[] = [
    {
      label: "Job.ConfirmAppointment",
      statuses: ["TECHCONF"],
      colour: "success",
      labelTicked: "Job.AppointmentConfirmed",
    },
    {
      label: "Job.Reschedule",
      statuses: ["TECHRETURN", "TECHMISS"],
      getStatus: () => {
        // TODO: dialog to confirm this will change to 'TECHMISS'
        return !!this.visitDate.value ? Promise.resolve("TECHRETURN") : this.openStatusChangeConfirmationDialog("TECHMISS", `Job was not visited.`);//Promise.resolve("TECHMISS");
      },
      colour: "warning",
      labelTicked: "Job.Reschedule"
    },
    { label: "Job.Parts", statuses: ["PARTREQ"], colour: "blue" },
    { label: "Job.PartsBackorder", statuses: ["PARTORDER"], colour: "blue", visibleCheck: () => this.showPartOrdered },
    { label: "Job.PartsBackorder", statuses: ["PARTORD"], colour: "blue", visibleCheck: () => this.showPartOrdered },
    // { label: "Quotation", statuses: ["QUOTREQ"], colour: "main" },
    {
      label: "Job.PartsAvailable",
      statuses: ["PARTAVAIL"],
      colour: "blue",
    },
    { label: "Job.Collected", statuses: ["TECHWORK"], colour: "info" },
    {
      label: "Job.Exchange",
      statuses: ["FINEX", "CXCEX"],
      colour: "info",
      getStatus: () => {
        // TODO: This should be a business Rule - ?
        // KWIKIOT: check if status exists before allowing it.?
        return !!this.visitDate.value ? Promise.resolve("FINEX") : this.openStatusChangeConfirmationDialog("CXCEX", 'Job was not visited.')//.then((res) => !res ? "" : null);
      },
      visibleCheck: () => !this.codJob
    },
    {
      label: "Job.QuoteRequested",
      statuses: ["QUOTREQ"],
      colour: "info"
      /*visibleCheck: () => {
        return this.isCodJob();
      }*/
    },
    {
      label: "Job.QuoteSent",
      statuses: ["QUOTSENT"],
      colour: "info",
      visibleCheck: () => {
        return this.extraStatus.includes("QUOTSENT");
      }
    },
    { label: "Job.Exchange", statuses: ["EXCHANGE"], colour: "warning" },
    {
      label: "System.Cancel",
      statuses: ["CXC"],
      colour: "danger",
      blockVisited: true,
      labelTicked: "Cancelled"
    },
    { label: "Job.Repaired", statuses: ["FIN"], colour: "success" },
    { label: "Job.Repaired", statuses: ["FINREPAIR"], colour: "success" },
  ];

  @ViewChild("errorsDialog") errorsDialog: TemplateRef<any>;
  @ViewChild("changeNextAction") changeNextAction: any;

  @Input() defaultTab = 'summary';
  @Input() useRouting = true;
  @Input()
  get boundJob(): JobForm {
    return this.job;
  }
  set boundJob(value: JobForm) {
    this.job = value;// assign job object here - form is only be displayed after component is properly inited
  }

  job: JobForm;
  resource: ResourceMasterDto;
  resourceUpdated: EventEmitter<ResourceMasterDto> = new EventEmitter();
  model: ModelMasterDto;

  codTypes: string[] = [];
  machine: FormGroup;
  showPrint = true;
  // printOptions = ["Default", "DamageReport"];// print options are controlled by the product settings
  printOptions = ["Default"];// print options are controlled by the product settings
  // each print option will have an associated product setting which will list the relevant sections to be displayed on the Printout
  printOptionSections: Record<string, string[]> = {
    // prodcut settings must be madce under 'JobPrintSections_Default' with the relevant sections to be displayed
    Default: ["job", "tech", "customer", "dealer", "machine", "codes", "signature", "lines", "journals"],
    // additional print options will be retreived under [JobPrintSections]_[PrintOptionName]
    DamageReport: ["job", "customer", "dealer", "machine", "codes", "noteExternal", "lines"],
  };

  isMobile: Observable<boolean>;

  public newLines: () => JobLineDto[];
  public newLoans: () => MachineJobDto[];

  get layoutName(): string {
    return "JobEdit";
  }

  showAllMachineJournals = false;
  get allJournals(): JobJournalDto[] {
    if(!this.job) return [];
    const jobCreatedDate = this.job.created;
    const machineJournals = this.job.machine?.journals?.filter(mj => this.showAllMachineJournals || mj.created >= jobCreatedDate) || [];
    const jobJournals = this.job.journals || [];
    return [...jobJournals, ...machineJournals].sort((a, b) => dateSort(a.created, b.created));
  }

  constructor(
    protected layoutService: WebLayoutService,
    private router: Router,
    public route: ActivatedRoute,
    public jobService: JobService,
    public machineService: MachineService,
    public productSettings: ProductSettingService,
    public lookups: LookupListService,
    fb: FormBuilder,
    private resourceService: ResourceService,
    private location: Location,
    private appQuery: AppQuery,
    private dialog: MatDialog,
    private pubSub: PublishSubscribe,
    responsive: BreakpointObserver,
    private translate: TranslateService,
    private snackBar: SnackBarService,
    private customerService: CustomerService,
    private loggingService: LoggingService,
    private keyboardService: KeyboardShortcutService,
    notificationService: NotificationService,
    private modal: NgbModal,
    private checklistService: ChecklistService,
    private zone: NgZone,
    public modelService: ModelService
  ) {
    super(layoutService, fb, false, notificationService);
    this.showAllMachineJournals = productSettings.booleanValue("JobJournalsShowAllMachineJournals");
    this.canPublicUpload = productSettings.booleanValue("JobCreateFileUploader");
    this.showAddHold = productSettings.booleanValue("JobCanAddHold");
    this.extraStatus = productSettings.stringValue("JobExtraWebStatus");
    JobVat.vatRate = productSettings.numericValue("VatIncluded") ? 0.0 : 0.15; // code smell: keep arb values in db
    this.showPartOrdered = productSettings.booleanValue("JobStatusPARTORDER");
    this.showDelivered = productSettings.booleanValue("JobShowDelivered");
    this.checkStatusRoles = productSettings.booleanValue("JobStatusRoles");
    this.onlyAdhocHolds = productSettings.booleanValue("JobAdhocHoldsOnly");
    this.hiddenTabs = this.getHiddenTabs();
    this.isMobile = responsive
      .observe(Breakpoints.Handset)
      .pipe(map(o => o.matches));
    }

    loadPrintOptions() {
    this.printOptions = this.productSettings.arrayValue("JobPrintOptions", this.printOptions);
    // this.printOptionSections = this.printOptions.reduce<Record<string, string[]>>((acc, val) => {
    //   return {
    //     ...acc,
    //     [val]: this.productSettings.arrayValue("JobPrintSections_" + val, ["job", "tech", "customer", "dealer", "machine", "codes", "signature", "lines", "journals"])
    //   }
    // }, this.printOptionSections);
  }

  getHiddenTabs(): string[] {
    const showChecklist = this.productSettings.booleanValue('JobShowChecklist');
    return this.appQuery.loginStatus === LoginStatus.True
    ? [ showChecklist ? '' : 'checklist' ]
    : this.productSettings.stringValue("JobPublicHiddenTabs").split(",").concat(['checklist']);
    // always hide checklist from public view (for now)
  }

  allowSpecialLineEdit = false;
  get showSpecialLineEdit(): boolean {
    // @TODO - have roles discussion and try to remove this from SYSADMIN as it's very limiting with who...
    return this.job.closed && this.appQuery.hasRoles(["SYSADMIN"]) && !this.allowSpecialLineEdit;
  }

  public get linesEditable(): boolean {
    // console.log(!this.isReadonly || this.appQuery.hasRoles(["SYSADMIN"]))
    return !this.isReadonly || this.allowSpecialLineEdit;
  }

  public get isReadonly(): boolean {
    return this.preventEdit || !!this.job.closed;
  }

  public get preventEdit(): boolean {
    return !this.job || !this.userCanEdit;
  }

  updateCanChange() {
    if (this.job && this.jobStatuses && !this.job.closed) {
      const stat = this.jobStatuses.item(this.job.statusId);
      if (!stat) return;
      this.canChangeFrom = this.appQuery.hasRoles(stat.from) || !this.checkStatusRoles;
    }
  }

  private extraButtons(extraButtonRoles: string[]): void {
    const roles = this.appQuery.hasRoles(extraButtonRoles);
    const setting = this.productSettings.stringValue("RibbonSubmitEdiTitle");
    this.extraLabel = setting;
    this.showExtraButton = !!setting;

    if (this.showExtraButton && roles) {
      for (let i = 1; i < 10; i++)
      {
        const label = this.productSettings.stringValue("RibbonSubmitEdiText" + i);
        const edi = this.productSettings.stringValue("RibbonSubmitEdiName" + i);
        const journal = this.productSettings.stringValue("RibbonSubmitEdiJournalType" + i) || "COMMENT";
        if (!!label /*&& _viewModel.Context.AllowFeature<frmJobEdit>("CanSeeRibbonSubmitEdi" + i)*/) {
          const id = this.productSettings.stringValue("RibbonSubmitEdiName" + i);
          this.extraMenu.push({label, journal, edi});
        }
      }
    }
  }

  protected createForm() {
    const required = /*this.productSettings.stringValue("CustomerCustomStringValue1")? Validators.required :*/ null;

    this.machine = MachineMasterComponent.createFormGroup(this.formBuilder);
    this.form = this.formBuilder.group({
      statusId: "",
      consent: ["", required],
      contact: "",
      address: "",

      // Creating a Separate Group For the Codes to have Group Validation indication on the TAB set
      codes: this.formBuilder.group({
        diagnosticCodeId: "",
        componentCodeId: "",
        repairCodeId: "",
        faultCodeId: "",
        typeId: ["", Validators.required],// add journals to machine
        field1: "",
        field2: "",
        field3: "",
        field4: "",
        field5: "",
        purchaseOrderNumber: "",
        customerRef: "",
        ourRef: ""
      }),

      faultDescription: [
        "",
        this.validationFunctions("JobFaultDescriptionLength")
      ],
      noteInternal: ["", this.validationFunctions("JobNoteInternalLength")],
      noteExternal: ["", this.validationFunctions("JobNoteExternalLength")],
      visitDate: "",
      visited: "",
      hasConsumables: "",
      booked: null,
      nextAction: null,
      nextActionReason: ["", Validators.required],
      machine: this.machine,
      closed: "",
      /*,
      machine: this.formBuilder.group({
        modelId: "",
        name: "",
        dateOfPurchase: "",
        field1: "",
        field2: ""
      }),
*/
      journals: this.formBuilder.array([]),
      jobLines: this.formBuilder.array([]),
      holds: this.formBuilder.array([]),
      machines: "",
      payment: this.formBuilder.group({
        receipt: ["", Validators.required],
        paid: [0, Validators.required]
      })
    });
    super.createForm();
    this.payment.disable();
    this.nextActionReason.disable();

    // Subscribe to form model changes rather than adding 'onClick' envents to the fields themselves
    this.form.get("closed").valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
        this.closeJob(val);
    });

    // item.get("status").statusChanges.subscribe(val => {
    //   if (val && val !== "DISABLED") {
    //     textFld.setValidators(
    //       [Validators.required, Validators.minLength(this.productSettings.numericValue("JobJournalTextLength"))]);
    //   } else {
    //     textFld.clearValidators();
    //   }
    //   textFld.updateValueAndValidity();
    // });
    // this.form.statusChanges.subscribe((stat) => {
    //   console.log("Form Status", stat);
    // });
    this.form.statusChanges.subscribe((val) => {
      // console.log("Form Status", val);
    });
  }

  get payment(): FormGroup {
    return this.form.get("payment") as FormGroup;
  }

  get closed(): FormControl {
    return this.form.get("closed") as FormControl;
  }

  get journals(): FormArray {
    return this.form.get("journals") as FormArray;
  }

  get jobLines(): FormArray {
    return this.form.get("jobLines") as FormArray;
  }

  get loans(): FormArray {
    return this.form.get("loans") as FormArray;
  }

  get holds(): FormArray {
    return this.form.get("holds") as FormArray;
  }

  get statusId(): FormControl {
    return this.form.get("statusId") as FormControl;
  }

  get visitedControl(): FormControl {
    return this.form.get("visited") as FormControl;
  }

  get visitDate(): FormControl {
    return this.form.get("visitDate") as FormControl;
  }

  get booked(): FormControl {
    return this.form.get("booked") as FormControl;
  }

  get nextAction(): FormControl {
    return this.form.get("nextAction") as FormControl;
  }

  get nextActionReason(): FormControl {
    return this.form.get("nextActionReason") as FormControl;
  }

  notifyError(error: string) {
    this.snackBar.danger(error);
    this.loggingService.logException(error);
  }

  notifyJobLoadError() {
    this.notifyError("Invalid Job Details or Access permissions");
  }

  techDetailsPubliclyVisible = false;
  // signOnGlass = false;
  canOverrideSign = false;
  hiddenJobAttachmentTypes: string[] = [];
  ngOnInit() {
    this.loadPrintOptions();
    this.hiddenJobAttachmentTypes = this.productSettings.arrayValue("JobHiddenAttachmentTypes", ["SIG"]);
    // this.signOnGlass = this.productSettings.booleanValue("JobSignOnGlass");// this is controlled via Job Hold business rules
    this.canOverrideSign = this.appQuery.hasRoles(this.productSettings.arrayValue("JobSignOnGlassOverride", []));
    this.tenant = this.route.snapshot.paramMap.get("tenant");
    this.activeTab = this.defaultTab || this.activeTab;
    this.techDetailsPubliclyVisible = this.productSettings.booleanValue("JobTechDetailsPubliclyVisible");
    this.jobAtBranch = this.productSettings.booleanValue("JobAtBranch");
    this.showJobErrors = this.productSettings.booleanValue("JobShowErrors");
    const repButton = this.productSettings.stringValue("JobButtonRepaired");
    if (repButton) {
      const btn = this.buttons2.find(b => b.label === "Job.Repaired");
      btn.statuses = repButton.split(",");
    }

    // this.extraButtons();

    this.codTypes = this.productSettings.stringValue("JobTypesCOD").split(",");
    super.ngOnInit();
    if (this.useRouting) {
      this.getJobFromRoute()
      .pipe(
        switchMap(job => {
          return forkJoin({
            job: of(job) as Observable<JobForm>,
            settings: this.getFieldSettings() as Observable<FieldSettings>,
            jobStatuses: this.lookups.lookupListEx<JobStatusDto>("CodeJobStatus"),
            jobTypes: this.lookups.lookupListEx<JobTypeDto>("CodeJobType"),
            holdTypes: this.lookups.lookupListEx<JobHoldTypeDto>("CodeHoldType")
          });
        })
      )
      .subscribe(
        (combined) => {
          this.fieldSettings = combined.settings;
          this.entityId = combined.job.jobId;
          this.jobStatuses = combined.jobStatuses;
          this.jobTypes = combined.jobTypes;
          this.holdTypes = combined.holdTypes;
          this.initNotificationListener(this.tenant, this.entityType, this.entityId);// dependant on jobID
          this.displayJob(combined.job);
        },
        () => {
          this.notifyJobLoadError();
          this.back(this.location, this.router, this.route, "../list");
        }
      );
    } else {
      // expect job to assigned via Component Property
      if(this.job) {
        this.entityId = this.job.jobId;
        this.initNotificationListener(this.tenant, this.entityType, this.entityId);// dependant on jobID
        this.displayJob(this.job);
      }
      else
        this.notifyJobLoadError();
    }

    this.route.fragment.subscribe(frag => {
      this.activeTab = frag || this.activeTab;
    });



    // combineLatest([this.appQuery.$roles, this.appQuery.$loginStatus])
    //   .pipe(this.notDisposed()).subscribe(([roles, loginStatus]) => {

    // });

    // Use Route Data to set 'Public' state
    this.route.data
    .pipe(map((data) => data["isPublic"]), filter(flag => flag))
    .subscribe(
      (isPublic: boolean) => {
        this.isPublic = isPublic;
      }
    );
  }

  schedulingRoles = ["CC"];
  setupRoles() {

    this.schedulingRoles = this.productSettings.arrayValue("JobSchedulingRoles", this.schedulingRoles);
    const roles = this.appQuery.roles;
    const loginStatus = this.appQuery.loginStatus;

    roles.forEach(r => {
      this.roleFieldHiddenMap[r] = this.productSettings.arrayValue("JobDetailsFieldsHidden_" + r, []);
    });

    this.isFinance = this.appQuery.hasRoles(["FINANCE"]);
    this.isTech = this.appQuery.hasRoles(["TECH"]);
    this.userCanEdit =
      loginStatus === LoginStatus.True &&
      !!roles.length &&
      roles.some(r => r !== "VIEW");
    this.isAdmin =
      loginStatus === LoginStatus.True && this.appQuery.hasRoles(["ADMIN"]);
    this.isMan =
      loginStatus === LoginStatus.True && this.appQuery.hasRoles(["MAN"]);
    this.canSeeContract =
      loginStatus === LoginStatus.True &&
      this.appQuery.hasRoles(["CONTRACT"], false);
    this.extraButtons(["MAN", "ADMIN"]);

  }

  initKeyboardListener(): void {
    this.listeners.push(this.keyboardService.listen({ ...KeyboardShortcuts.SAVE, handler: () => this.saveIfPossible() }));
    this.listeners.push(this.keyboardService.listen({ ...KeyboardShortcuts.CANCEL, handler: () => this.cancelIfPossble() }));
  }

  getJobFromRoute(){
    this.loading = true;
    return this.route.paramMap
    .pipe(
      switchMap((params: ParamMap) =>
        this.jobService.getJob(params.get("jobId"), params.get("check"))
      ),
      tap(() => {
        this.loading = false;
      })
    );
  }

  public codeOnly(item: any): string {
    return codeOnly(item);
  }

  public canChangeTo(button: StatusButton): boolean {
    return !this.checkStatusRoles || button.statuses.some(s => {
      if(this.jobStatuses.item(s)) {
        return this.appQuery.hasRoles(this.jobStatuses.item(s).to);
      } else {
        return false;
      }
    });
  }

  /**
   * Match The Static StatusButtons against the current JobStatuses and use Overrides provided in the JobTypes
   */
  filterButtons(buttons: StatusButton[]): StatusButton[] {
    return buttons
    .filter(b =>
      b.statuses.some(s => !this.jobStatuses || this.jobStatuses?.containsKey(s))
    )
    .filter(b => {
      // Job Type Map may contain additional button/status filters
      if (this.checkJobTypesForStatuses(this.job.typeId)) {
        const jobTypeStatusMap = Object.keys(this.jobTypes.item(this.job.typeId).statuses);
        return b.statuses.some(s => jobTypeStatusMap.includes(s));
      }
      return true;
    })
    .map(b => {
      if (this.checkJobTypesForStatuses(this.job.typeId)) {
        const overrideStatuses = this.jobTypes.item(this.job.typeId).statuses;
        b.label = overrideStatuses[b.statuses[0]];
      }
      return b;
    });
  }

  checkJobTypesForStatuses(typeId: string): boolean{
    return this.jobTypes?.containsKey(typeId)
      && this.jobTypes.item(typeId).statuses
      && !!Object.keys(this.jobTypes.item(typeId).statuses).length;
  }

  hasString(settingId: string): boolean {
    return !!this.productSettings.stringValue(settingId);
  }

  getString(settingId: string): string {
    return this.productSettings.stringValue(settingId);
  }

  // Hail Mary on this function - it's a bit of a mess
  private createHoldGroup(hold: JobHoldDto, disableStatus: boolean) {
    const item = this.formBuilder.group({
      holdId: "",
      status: "",
      typeId: ["", Validators.required],
      clearedUserId: "",
      text: "",
      gpscoordinates: "",
      contactId: "",
      signatureFile: null, // used temporarily to store the signature file - this is attached to the Job first and the Hold is then given the AttachmentID ?
      signatureDataURL: "", // temp storage for easy retreival
      attachmentId: ""
    });

    item.patchValue({
      holdId: hold.holdId,
      status: hold.status,
      typeId: hold.typeId,
      clearedUserId: hold.clearedUserId,
      text: "",
      gpscoordinates: hold.gpsCoordinates,
      contactId: hold.contactId,
      signatureFile: null,
      signatureDataURL: "", // temp storage for easy retreival
      attachmentId: hold.attachmentId
    });

    if (hold.status && disableStatus) {
      // console.log("Disabling Status", hold.status);
      item.get("status").disable();
    }
    const textFld = item.get("text");
    item.get("status").statusChanges.subscribe(val => {
      // console.log("Status Changed", val);
      if (val && val !== "DISABLED") {
        textFld.setValidators(
          [Validators.required, Validators.minLength(this.productSettings.numericValue("JobJournalTextLength"))]);
      } else {
        textFld.clearValidators();
      }
      textFld.updateValueAndValidity();
    });

    // item.statusChanges.subscribe(val => {
    //   console.log("Hold Status Changed", val);
    // });
    return item;
  }

  public addJournal() {
    // this.allErrors();
    const item = this.formBuilder.group({
      text: [
        "",
        Validators.minLength(
          this.productSettings.numericValue("JobJournalTextLength")
        )
      ]
    });
    this.journals.push(item);
  }

  private validationFunctions(setting: string): ValidatorFn[] {
    return []; /*
    const value = this.productSettings.numericValue(setting);
    return value ? [ Validators.minLength(value)] : [];*/
  }

  // Generate a string indicating the min-required chars for a field
  requiredChars(formControl: AbstractControl | string, productSetting: string) {
    if (typeof formControl === "string") {
      formControl = this.form.get(formControl);
    }
    const minLength = this.productSettings.numericValue(productSetting);
    const field = formControl.value?.length || 0;
    const left = Math.max(0, minLength - field);

    return left ? "(" + left + ")" : "";
  }

  public deleteJournal(index: number) {
    this.journals.removeAt(index);
  }

  customer: CustomerMasterDto;
  public displayJob(job: JobDto) {
    this.allowSpecialLineEdit = false;

    this.customerService.getCustomer(job.customerId).pipe(take(1)).subscribe(val => this.customer = val);
    const key = KeyGetter.mapskey;
    this.googleMapUri =
     `https://maps.googleapis.com/maps/api/staticmap?key=${key}&zoom=15&scale=false&size=344x300&&markers=`;// @todo - move to settings
    const jobTypes = this.productSettings.stringValue("JobTypesCOD");
    this.codJob = jobTypes.includes(job.typeId);
    this.job = job as JobForm;
    this.updateCanChange();
    job.consent = job.consent || "";

    const valTypes = this.productSettings.stringValue("JobTypesValidation");
    this.showValidation = valTypes.includes(job.statusId);

    this.jobService.loadCategories().subscribe(() => {
      this.updateAllowedCodes(this.model);
      this.jobService.loadCodesConfig().subscribe();
    });

    if (!this.model || this.model.code !== job.machine.modelId) {
      this.jobService
        .getModel(job.machine.modelId)
        .subscribe(m => {
          this.model = m;
          job.machine.model = m;
          MachineMasterComponent.setFormData(
            job.machine,
            this.machine,
            this.productSettings
          );
          this.updateAllowedCodes(m);
        });
    } else if (this.model && this.model.code === job.machine.modelId) {
      setTimeout(() => {// @todo - remove this timeout
        job.machine.model = this.model;
        MachineMasterComponent.setFormData(
          job.machine,
          this.machine,
          this.productSettings
        );
        this.updateAllowedCodes(this.model);
      }, 10);
    }

    if (job.resourceId) {
      if((this.resource && job.resourceId !== this.resource.code) || !this.resource) {
        this.resourceService
          .getResource(job.resourceId)
          .toPromise()
          .then(r => {
            this.resource = r;
            this.resourceUpdated.next(r);
          });
        }
    } else {
      this.resource = null;
    }

    // Move Codes to it's own FormGroup
    (job as JobForm).codes = {
      diagnosticCodeId: job.diagnosticCodeId,
      componentCodeId: job.componentCodeId,
      repairCodeId: job.repairCodeId,
      statusId: job.statusId,
      faultCodeId: job.faultCodeId,
      typeId: job.typeId,
      field1: job.field1,
      field2: job.field2,
      field3: job.field3,
      field4: job.field4,
      field5: job.field5,
      purchaseOrderNumber: job.purchaseOrderNumber,
      customerRef: job.customerRef,
      ourRef: job.ourRef
    };
    this.form.reset(job, { emitEvent: false });
    this.form.get("visited").valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
      this.setVisited(val);
    });

    if(this.productSettings.booleanValue("MachineUnlock")){
      // Prevent Editing of Existing Machines
      this.machine.disable();
    }


    if (this.isReadonly || this.appQuery.loginStatus !== LoginStatus.True) {
      this.setClosedState();
      this.emptyNumber = "";
    } else {
      this.translate.get(this.emptyNumberKey).subscribe(val => this.emptyNumber = val);
      this.validate(true);
    }

    this.holds.clear();
    const holdControls = this.job.holds.map(h => this.createHoldGroup(h, true));
    // this.form.setControl("holds", this.formBuilder.array(holdControls));
    holdControls.forEach(h => this.holds.push(h));
    // this.form.get("holds").controls.push()

    this.booked.reset(job.booked, { emitEvent: false });
    this.visitDate.reset(job.visitDate, { emitEvent: false });
    this.visitedControl.reset(!!job.visitDate, { emitEvent: false });

    if (this.isPublic || this.form.disabled || this.job.closed) {
      this.visitedControl.disable({ emitEvent: false });
    }

    this.checkbooked(job.statusId);

    const journals = this.journals;
    while (journals.length) {
      journals.removeAt(0);
    }
    /*
    const lines = this.jobLines;
    while (lines.length) {
      lines.removeAt(0);
    }*/

    if (!this.preventEdit) {
      this.addJournal();
    }

    if (this.jobStatuses) {
      const stat = this.jobStatuses.item(this.job.statusId);
      if (!stat) return;
      this.canChangeFrom = !this.checkStatusRoles || !stat.from ||  this.appQuery.hasRoles(stat.from);
    }
    this.form.markAsPristine();
    // console.log("Job Loaded", 'Job', job);
  }

  private setClosedState(): void {
    this.form.disable({ emitEvent: false});
    if (this.isAdmin) {
      this.closed.enable({ emitEvent: false });
    }
    this.machine.disable({ emitEvent: false});
    if (!this.preventEdit)
      this.journals.enable({onlySelf: true, emitEvent: false});
  }

  /**
   * Allowed Codes are updated from the ModelMasterDto "CATEGORIES" in the Service
   * @param model
   */
  public updateAllowedCodes(model: ModelMasterDto) {
    if (this.jobService.updateAllowedCodes(model)) {
      this.filterCloseCodes = this.jobService.filterCloseCodes.bind(this.jobService);
      this.filterComponentCodes = this.jobService.filterComponentCodes.bind(this.jobService);
      this.filterDiagnosticCodes = this.jobService.filterDiagnosticCodes.bind(this.jobService);
      this.filterFaultCodes = this.jobService.filterFaultCodes.bind(this.jobService);
    }
  }

  getQueryPathExtras(listName: CodeListName): string {
    switch(listName) {
      case "CodeJobClose":
        return this.getFilterListValueForList(listName);
      case "CodeJobComponent":
        return this.getFilterListValueForList(listName) || this.job.machine?.model?.categories;
      case "CodeJobDiagnostic":
        return this.getFilterListValueForList(listName) || [this.job.machine?.modelId];
      case "CodeJobFault":
        return this.getFilterListValueForList(listName);
      // case "CodeJobStatus":
      //   return this.getFilterListValueForList("CodeJobDiagnostic");
      case "CodeJobType":
        return this.getFilterListValueForList(listName);
      case "StockMaster":
        return this.getFilterListValueForList(listName);
      default:
        return "";
        // check the service which dependency uses this key
    }
  }

  getFilterListValueForList(listName: CodeListName){
    let filterValueListName = "";
    filterValueListName = this.jobService.codeGroupConfig?.[listName] || "";
    switch(filterValueListName) {
      case "CodeJobClose":
        return this.form.get("codes.repairCodeId").value;
      case "CodeJobComponent":
        return this.form.get("codes.componentCodeId").value;
      case "CodeJobDiagnostic":
        return this.form.get("codes.diagnosticCodeId").value;
      case "CodeJobFault":
        return this.form.get("codes.faultCodeId").value;
      case "CodeJobStatus":
        return this.form.get("statusId").value;
      case "CodeJobType":
        return this.form.get("codes.typeId").value;
      case "ModelMaster":
        return this.form.get("machine").value.modelId;
      case "CodeMachineCategory_1":
        return this.form.get("machine").value.categories[0];
      case "CodeMachineCategory_2":
        return this.form.get("machine").value.categories[1];
      case "CodeMachineCategory_3":
        return this.form.get("machine").value.categories[2];
      case "CodeMachineCategory_4":
        return this.form.get("machine").value.categories[3];
      case "CodeMachineCategory_5":
        return this.form.get("machine").value.categories[4];
      default:
        return "";
        // check the service which dependency uses this key
    }
  }

  public canSchedule() {
    return this.canChangeFrom && !this.closed.value && this.appQuery.hasRoles(this.schedulingRoles); // && this.jobStatuses.item("TECH").to;
  }

  checkbooked(status: string) {
    const control = this.form.get("booked");
    if (["TECHRETURN", "TECHMISS"].indexOf(status) > -1 && !this.isReadonly) {
      control.enable();
    } else {
      control.disable();
      control.reset(this.job.booked);
    }
  }

  changeStatus(button: StatusButton) {
    if(button.confirmAction) {
      button.confirmAction().then((result) => {
        if(result){
          this.changeStatusInternal(button);
        }
      });
    } else {
      this.changeStatusInternal(button);
    }
  }

  private async changeStatusInternal(button: StatusButton) {
    // alert("This status has Checklist dependencies. Please goto 'Validation' to resolve.")
    let newStatus = "";
    if (this.statusActive(button)) {
      newStatus = this.job.statusId;
      button =
        this.buttons1.find(b => b.statuses.includes(newStatus)) ||
        this.buttons2.find(b => b.statuses.includes(newStatus));
    } else {
      if (button.getStatus)
        newStatus = await button.getStatus();
      else
        newStatus = button.statuses[0];

      if (newStatus === "CXC") {
        // this.form.controls["hasLabour"].setValue(false, { emitEvent: true, emitModelToViewChange: true, emitViewToModelChange: true });
      }

      if (button.blockVisited && !!this.visitDate.value) {
        this.setVisited(false);
      }
    }
    if (!!button && button.blockVisited) {
      this.visitDate.disable();
    } else {
      this.visitDate.enable();
    }

    if(newStatus) {
      this.statusId.setValue(newStatus);
      this.checkbooked(newStatus);
      this.statusId.markAsDirty();
    }
  }

  public setLines(lines: JobLineDto[]){
    this.processLineData(this.job.lines, lines);
  }

  public doSaveChanges(): Observable<JobDto> {
    // Only New journals are retained for the API step - clear old ones so that the payload not repeated
    // Note: In future we must move the Journals to a separate API call
    const job = {
      ...this.job,
      machine:
      {
        ...this.job.machine,
        journals: this.job.machine.journals?.filter(j => j.isNew) || []
      },
      journals: this.job.journals?.filter(j => j.isNew) || [],
    };
    // this.form.markAsPristine();
    const jobData = this.form.getRawValue();
    // return of(jobData);
    MachineMasterComponent.getFormData(job.machine, this.machine);
    job.contact = jobData.contact;
    job.address = jobData.address;

    // Do not send back certain information for Updating
    job.contract = null;
    job.edi = null;
    job.messages = null;
    job.followUps = null;
    job.errors = [];
    job.attachments = [];

    job.statusId = codeOnly(jobData.statusId);
    const jobCodes = jobData.codes;
    job.typeId = codeOnly(jobCodes.typeId);
    job.faultCodeId = codeOnly(jobCodes.faultCodeId);
    job.diagnosticCodeId = codeOnly(jobCodes.diagnosticCodeId);
    job.componentCodeId = codeOnly(jobCodes.componentCodeId);
    job.repairCodeId = codeOnly(jobCodes.repairCodeId);
    job.customerRef = trim(jobCodes.customerRef);
    job.ourRef = trim(jobCodes.ourRef);
    job.field1 = trim(jobCodes.field1);
    job.field2 = trim(jobCodes.field2);
    job.field3 = trim(jobCodes.field3);
    job.field4 = trim(jobCodes.field4);
    job.field5 = trim(jobCodes.field5);
    job.purchaseOrderNumber = trim(jobCodes.purchaseOrderNumber);

    job.faultDescription = trim(jobData.faultDescription);
    job.noteInternal = trim(jobData.noteInternal);
    job.noteExternal = trim(jobData.noteExternal);
    job.consent = trim(jobData.consent);
    job.visitDate = jobData.visitDate || null;
    job.booked = jobData.booked;
    job.closed = jobData.closed ? 1 : 0;

    // PROCESS HOLDS
    for (let x = 0; x < job.holds.length; x++) {
      const hold = job.holds[x];
      const holdData = jobData.holds[x];
      if (holdData.status) {
        const journal = { // journal ||
          typeId: "JOBHOLD",
          text: trim(holdData.text),
          from: codeOnly(holdData.typeId),
          to: holdData.status !== JobHoldTypes.NEW ? holdData.status : "",
          created: new Date(),
          by: ""
        };
        if (journal.text) {
          job.journals.push(journal);
        }
        hold.typeId = codeOnly(holdData.typeId);
        if (holdData.status !== JobHoldTypes.NEW) {
          hold.status = holdData.status;
          hold.clearedUserId = hold.clearedUserId || this.appQuery.username;
          hold.notes = holdData.text;
          hold.attachmentId = holdData.attachmentId;
          hold.contactId = holdData.contactId;
          hold.gpsCoordinates =  holdData.gpscoordinates && GeoPosToGpsCoordinates(holdData.gpscoordinates) || null;
        } else
          hold.status = "";
      }
    }

    if (this.jobClosed) {
      const journal = { // journal ||
        typeId: "CHANGECLOSED",
        text: "Job was Closed",
        from: "Open",
        to: "Close",
        created: new Date(),
        by: ""
      };
      job.journals.push(journal);
    }

    // eslint-disable-next-line guard-for-in
    for (const jourData of jobData.journals) {
      const journal: JobJournalDto = {
        typeId: "COMMENT",
        text: trim(jourData.text),
        from: "",
        to: "",
        created: new Date(),
        by: ""
      };
      if (journal.text) {
        job.journals.push(journal);
      }
    }
    if (jobData.nextActionReason) {
      const journal: JobJournalDto = {
        typeId: "CHANGENEXTACTIONDATE",
        text: trim(jobData.nextActionReason),
        from: job.nextAction.format(),
        to: (jobData.nextAction as Date).format(),
        created: new Date(),
        by: ""
      };
      job.journals.push(journal);
      job.nextAction = convertToDate(jobData.nextAction);
    }

    if (this.payment.enabled) {
      const journal: JobJournalDto = {
        typeId: "PAYMENTSUCCESS",
        text: `Manual Payment. Receipt: ${jobData.payment.receipt}, Paid: ${jobData.payment.paid}`,
        from: "",
        to: "MANUAL",
        created: new Date(),
        by: ""
      };
      job.journals.push(journal);
      this.payment.disable();
    }

    this.loanUnitCount = job.machines.length;

    // jobmachines
    job.machines = jobData.machines;

    // Check Existing Job Lines (or modified ones)
    let i = job.lines.length;
    while (i--) {
      const jobLine = job.lines[i];
      // for (const jobLine of this.job.lines) {
      const line = jobData.jobLines.find(l => l.lineId === jobLine.lineId);// find job-line by id within JobData

      if (!line || !line.quantityOrdered || !line.itemId)
        job.lines.splice(i, 1);// was removed in the form - remove from the job data
    }
    this.processLineData(job.lines, jobData.jobLines);

    this.loading = true;
    const result = this.jobService.updateJob(job)
    .pipe(
      tap((jobResult) => {
        this.displayJob(jobResult);
        // this.payment.disable();
        this.loading = false;
      }),
      catchError(err => {
        // throw err;
        throw new Error(`Job Update failed - ${err?.message}`);
      })
    );
    return result;
  }

  processLineData(jobLines: JobLineDto[], jobLinesFormData) {
    const useWarehouse = this.productSettings.booleanValue("JobLineUseWarehouse") || false;
    for (const lineData of jobLinesFormData) {
      // in each JobFormData- check if we have it in the JobAlready
      let jobLine = jobLines.find(
        l => l.lineId === lineData.lineId && lineData.lineId !== "NEW"
      );
      // we have basic data?
      if (lineData.line1 && lineData.quantityOrdered && !!lineData.line1) {
        if (!jobLine) { // not already there (could be new)
          jobLine = newJobLine("");
          jobLines.push(jobLine);
        }
        jobLine.lineId = lineData.lineId;
        jobLine.typeId = codeOnly(lineData.typeId);
        jobLine.itemId = codeOnly(lineData.itemId);
        jobLine.line1 = trim(lineData.line1);
        jobLine.price = +lineData.price;
        jobLine.cost = +lineData.cost;
        jobLine.mode = lineData.mode;
        jobLine.quantityOrdered = +lineData.quantityOrdered;
        jobLine.quantityDelivered = this.showDelivered ? +lineData.quantityDelivered : +lineData.quantityOrdered;
        jobLine.vatId = lineData.vatId;
        jobLine.vatRate = +lineData.vatRate;
        jobLine.resourceId = lineData.resourceId;
        if(useWarehouse)
        jobLine.warehouseId = this.resource?.warehouse || null;
      }
    }
  }

  showJobValidationError(){
    this.snackBar.danger('Please check the Form for Errors, then try again');
  }

  /**
   * Save Job without navigating
   */
  lineSave(){
    if (this.form.invalid){
      this.showJobValidationError();
      return;
    }
    this
    .doSaveChanges()
    .toPromise()
    .then(job => {
      this.displayJob(job);
    }).catch(e => {
      const message = `Failed Saving Line Changes - ${e?.message || "Unknown reason"}`;
      this.snackBar.danger(message);
      this.loggingService.logException(message);
    });
  }

  saveChanges() {
    if (this.form.invalid){
      this.showJobValidationError();
      return;
    }
    this.doSaveChanges()
      .toPromise()
      .then(
        job => {
          if (
            job.errors.length &&
            this.showJobErrors
          ) {
            // this.displayJob(job);
            // this.job.errors = job.errors;
            const ref = this.dialog.open(this.errorsDialog);
          }
        }
      ).catch(e => {
        const message = `Failed Saving Job - ${e?.message || "Unknown reason"}`;
        this.form.markAsDirty();
        this.snackBar.danger(message);
        this.loggingService.logException(message);
        this.cancelChanges();
      });
  }

  onChangeNextAction(days: number = 0) {
    this.nextActionReason.enable();
    const nextAction = convertToDate(this.nextAction.value);
    const nextActionReason = this.nextActionReason.value;
    this.nextAction.patchValue(nextAction.add(days, "day"));
    const ref = this.dialog.open(this.changeNextAction);
    ref.afterClosed().subscribe(result => {
      if (!result) {
        this.nextAction.reset(nextAction);
        this.nextActionReason.reset(nextActionReason);
      }
      this.nextActionReason.disable();
    });
  }

  cancelChanges() {
    this.getJobFromRoute()
    .subscribe(
      (freshJob: JobDto) => {
        this.displayJob(freshJob);
        this.onDataReloaded();
      },
      (err) => {});
  }

  setVisited(visited: boolean) {
    if (visited) {
      this.visitDate.setValue(Date.today());
      this.visitDate.markAsDirty();
      // this.hasLabour.setValue(false);
      // this.hasLabour.markAsDirty();
    } else {
      this.visitDate.setValue(null);
      this.visitDate.markAsDirty();
    }
  }

  columnGenerator(count: number) {
    return new Array(count);
  }

  columnButtons(buttons: StatusButton[], col: number, cols = 2) {
    const cnt = Math.ceil(buttons.length / cols);
    const start = col * cnt;
    return buttons
      .filter(b => !b.visibleCheck || b.visibleCheck())
      .slice(start, start + cnt);
  }

  statusActive(button: StatusButton): boolean {
    /* const status = button.statuses.length === 1 || !!this.visitDate.value ? button.statuses[0] : button.statuses[1];
    return this.statusId.value === status;*/
    return button.statuses.includes(this.statusId.value);
  }

  tabPageChange(event: NgbNavChangeEvent) {
    if (event.nextId === "back") {
      this.back(this.location, this.router, this.route, "../list");
    }
    // this.showPrint = event.nextId === "details";
    this.router.navigate(["."], {fragment: event.nextId, relativeTo: this.route, replaceUrl: true});
  }

  // how does the address get updated on the job?
  editAddress() {
    const modal = this.dialog.open(AddressComponent, {data: this.job.address});
    modal.afterClosed().subscribe(data => {
      if (data)
        this.form.markAsDirty();
    });
    return false;
  }

  editContact() {
    const modal = this.dialog.open(ContactComponent, {data: this.job.contact});
    modal.afterClosed().subscribe(data => {
      if (data)
        this.form.markAsDirty();
    });
    return false;
  }

  editDealerContact() {
    const modal = this.dialog.open(ContactComponent, {data: this.job.dealerContact});// this model is being written back to...(by the modal)...not a great look
    modal.afterClosed().subscribe(data => {
      if (data) {
        // this.job.dealerContact = data;
        this.form.markAsDirty();
      }
    });
    return false;
  }

  private addDays(date: Date, forward: boolean = true): Date {
    const inc = forward ? 1 : -1;
    const next = date.add(inc, "day");
    return next;
  }

  prevDate(date: AbstractControl, mindate?: NgbDateStruct) {
    let val = date.value;
    if (!val) {
      val = Date.today();
    }
    let newVal = this.addDays(convertToDate(val), false);
    if (mindate && newVal < convertToDate(mindate)) {
      newVal = convertToDate(mindate);
    }
    date.patchValue(newVal);
    date.markAsDirty();
  }

  nextActionZZ(): NgbDateStruct {
    return convertToNgbDate(this.nextAction.value);
  }

  nextDate(date: AbstractControl) {
    let val = date.value;
    if (!val) {
      val = Date.today();
    }
    date.patchValue(this.addDays(convertToDate(val), true));
    date.markAsDirty();
  }

  nextActionSelected(date: NgbDate) {
    this.nextAction.patchValue(convertToDate(date));
    this.nextAction.markAsDirty();
  }

  public saveJob(): Promise<JobDto> {
    let promise: Promise<JobDto>;
    if (this.form.dirty) {
      promise = this.doSaveChanges().toPromise();
    } else {
      promise = Promise.resolve<JobDto>(this.job);
    }
    return promise;
  }

  schedule() {
    if (this.form.invalid){
      this.showJobValidationError();
      return;
    }
    this.saveJob()
    .then(job => {
      const modalRef = this.modal.open(ScheduleJobComponent, { size: "xl" });
      (modalRef.componentInstance as ScheduleJobComponent).job = job;
      modalRef.closed.subscribe((result: JobDto) => {
        if (result) {
          this.getJobFromRoute()
          .subscribe(
            (freshJob: JobDto) => this.displayJob(freshJob),
            (err) => {});
        }
      });
    }).catch(e => {
      this.snackBar.danger(`Cannot Schedule Job with errors - ${e?.message || "Unknown reason"}`);
    });
    return false;
  }

  bookedStr() {
    const val = this.booked.value as Date;
    return val ? val.format() : "Not booked";
  }

  swipe() {
    /*
    const current = this.tabList.findIndex(t => t.id === currentPage);
    if (direction === "RIGHT" && current > 0) {
      this.tabs.select(this.tabList[current - 1].id);

    } else if (direction === "LEFT" && current < this.tabList.length) {
      this.tabs.select(this.tabList[current + 1].id);
    }*/
  }

  showResource(resourceId: string): boolean {
    this.pubSub.publish("resource_modal", this.resource || resourceId);
    return false;
  }

  showContract(contractId: string): boolean{
    this.pubSub.publish("contract_details", contractId);
    return false;
  }

  deleteVisit(visit: JobVisitDto) {
    const idx = this.job.visits.indexOf(visit);
    this.job.visits.splice(idx, 1);
    const visitDate = this.job.visits.length
      ? this.job.visits.slice(-1)[0].visited
      : null;
    if (visitDate) {
      this.form.patchValue({ visitDate });
    }
    this.form.markAsDirty();
  }

  canClearHold(holdType: string): boolean {
    const hold = this.holdTypes.item(holdType);
    return (
      hold &&
      (this.appQuery.roles.includes(hold.ownerRoleId) ||
        this.appQuery.roles.includes("SYSADMIN"))
    );
  }

  addHold() {
    const newHold: JobHoldDto = {
      holdId: "",
      typeId: "",
      clearedUserId: "",
      status: "New",
    };
    const holdGrp =  this.createHoldGroup(newHold, false);
    this.job.holds.unshift(newHold);
    this.holds.insert(0, holdGrp);
    this.form.markAsDirty();
  }

  deleteHold(index: number) {
    this.holds.removeAt(index);
    this.job.holds.splice(index, 1);
    this.form.markAsDirty();
  }

  async sendSms() {
    const stuff = this.findInvalidControls();

    const { UserModule } = await import(
      /* webpackChunkName: 'user' */ "../../../modules/user/user.module"
    );
    const ref = this.dialog.open(UserModule.components.sendSms, {data: {job: this.job, resource: this.resource}});
    ref.afterClosed().subscribe((msg: JobMessageDto) => {
      if (msg)
        this.job.messages.push(msg);
    });
  }

  addPublicFollowUp() {
    const dateTime = new Date();
    dateTime.setHours(dateTime.getHours() + 24, 0, 0, 0);
    const followup: JobFollowUpDto = {
      id: null,
      jobId: this.job.jobId,
      statusId: "OPEN",
      comment: "",
      method: "Call",
      type: "Feedback",
      priority: "MEDIUM",
      closed: 0,
      followUpBy: null,
      followUpDate: dateTime,
      loggedDate: new Date(),
      closedDate: null,
      closedBy: "",
      contact: ""
    };
    this.doShowPublicFollowUp(followup);
  }

  addFollowUp() {
    const dateTime = new Date();
    dateTime.setHours(dateTime.getHours() + 1, 0, 0, 0);
    const followup: JobFollowUpDto = {
      id: null,
      jobId: this.job.jobId,
      statusId: "OPEN",
      comment: "",
      method: "Call",
      type: "",
      priority: "MEDIUM",
      closed: 0,
      followUpBy: this.appQuery.username,
      followUpDate: dateTime,
      loggedDate: new Date(),
      closedDate: null,
      closedBy: "",
      contact: ""
    };
    this.doShowFollowUp(followup);
  }

  public extraMenuAction(item: MenuItem) {
    const id = this.job.jobId;
    this.job = null;
    this.jobService.submitJob(id, item.edi, item.journal).subscribe(job => this.displayJob(job));
  }

  extraButton(edi: JobEdiDto): MenuItem {
    const lastEdi = Math.max( ...this.job.edi.filter(e => e.name === edi.name).map(e => +e.ediId));
    return +edi.ediId === lastEdi && this.extraMenu.find(f => f.edi === edi.name);
  }

  closeJob(willClose: boolean) {
    this.form.patchValue({closed : willClose});
    this.form.markAsDirty();
    if (!willClose) {
      this.form.enable();
      this.payment.disable();
      this.holds.disable();
      this.nextActionReason.disable();
      this.form.updateValueAndValidity();
    } else {
      // this.setClosedState();
    }
    // this.job.closed = willClose ? 1 : 0;// dont set this until we save a new payload
    if (willClose && !this.job.completed)
      this.job.completed = Date.today();
    if (willClose) this.jobClosed = true;
    else this.jobOpened = true;
  }

  async doShowPublicFollowUp(followup: JobFollowUpDto) {
    const { UserModule } = await import(
      /* webpackChunkName: 'user' */ "../../../modules/user/user.module"
    );
    followup.jobId = this.job.jobId;
    const data = { followup, job: this.job };
    this.openFollowUpModal(UserModule.components.publicFollowUp, data);
  }

  async doShowFollowUp(followup: JobFollowUpDto) {
    const { UserModule } = await import(
      /* webpackChunkName: 'user' */ "../../../modules/user/user.module"
    );
    followup.jobId = this.job.jobId;
    const data = { followup, job: this.job };
    this.openFollowUpModal(UserModule.components.followUp, data);
  }

  openFollowUpModal(innerComponent: any, data: { followup: JobFollowUpDto, job: JobDto}) {
    const ref = this.dialog.open(innerComponent, {data, width: "800px" });
    ref.afterClosed().pipe(this.notDisposed()).subscribe(folup => {
      if (!folup)
        return;
      const id = this.job.followUps.findIndex(f => f.id === folup.id);
      if (id !== -1) {
        this.job.followUps[id] = folup;
        this.snackBar.success("Followup Updated");
      }
      else {
        this.job.followUps.push(folup);
        this.snackBar.success("Followup Added");
      }
    });
  }

  formatDate(date: Date): string {
    return formatFollowUpDate(date);
  }

  showFollowUp(followup: JobFollowUpDto) {
    this.doShowFollowUp(followup);
    return false;
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  public async createDeliveryNote() {
    if (this.form.invalid){
      this.showJobValidationError();
      return;
    }
    const job = await this.saveJob();
    this.jobService.createDeliveryNote(this.job.jobId)
    .pipe(catchError((error, caught) => {
      // return to previous state if error ocurrs
      window.location.reload();// very ugly (router navigation is also a bit dodgy)
      return of(false);
    }))
    .subscribe((note) => {
      if (note)
        this.router.navigate(["deliverynote", note], {
          relativeTo: this.route,
        });
    });
  }

  viewAttachment(attachmentId: string) {
    this.router.navigate(["."], {fragment: 'documents', relativeTo: this.route, replaceUrl: true});
  }

  attachmentUploaded(attachment: BaseAttachmentDto){
    this.job.attachments.push(attachment);
  }

  roleFieldHiddenMap: {[role: string]: string[]} = {};
  showField(fieldName: string, defaultValue: boolean = true) {
    // Special Override that hivdes specific fields for Specific Roles
    // if all role field hidden maps are there - hide field
    if(Object.keys(this.roleFieldHiddenMap).length && this.appQuery.roles.every(role => this.roleFieldHiddenMap[role]?.includes(fieldName))) {
      return false;
    }
    return super.showField(fieldName, defaultValue);
  }

  /**
   * Add Journals to Machine
   * mark entries as 'isNew' so they are not removed on save
   */
  addMachineJournalEntry(journal: JobJournalDto) {
    this.job.machine.journals = this.job.machine.journals || [];
    this.job.machine.journals.push({...journal, isNew: true});
    this.form.markAsDirty();
  }

  notifyEntityAction(action: string, tenant: string, type: string, id: string, data: any) {
    // this.snackBar.info(`Job - ${id} - ${data}`);
    console.log("Entity Action", action, tenant, type, id, data);
    if(data === 'updated') {
      this.onUpdateNotificationReceived(data);
      this.snackBar.open(
        "This Job has been updated by another user. Please refresh the page to see the latest changes.",
        "Refresh",
        SnackBarBaseService.getOptions("warning", -1)
      )
      .then(ref => ref.onAction().subscribe(() => {
        this.cancelChanges();
      }))
      .catch(err => {
        console.error("Error opening snackbar", err);
      });
    }
  }

  get canUnlockMachine() {
    return this.appQuery.hasRoles(this.productSettings.arrayValue("MachineUnlock", ["ADMIN", "MAN", "SUPER"])) && this.productSettings.booleanValue("MachineUnlock");
  }

  // checklistUnlocked = false;
  get showUnlock() {
    return this.appQuery.hasRoles(["ADMIN", "MAN", "SUPER"]) && this.checklistLocked;
  }

  get checklistLocked() {
    return this.job.checklist?.closed;
  }

  /**
   * Unlock the Checklist
   * Probably the most brittle part of the system
   */
  unlockChecklist() {
    this.launchReasonModal("Unlock Checklist", "Provide a reason for Unlocking the Checklist", this.editReasonBody, (modal) => {
      this.addJobJournal(this.editReasonText, "", "", "CHANGECHECKLISTREASON",);
      this.form.markAsDirty();
      this.saveJob().then(() => {
        checkUntilExists(() => !!this.checklistRef && !this.checklistRef.isBusyLoading(), () => {
          this.checklistRef.unlockChecklist();
          modal.close();
        });
      });
    });
  }

  editReasonText = "";
  editReasonBodyText = "";
  launchReasonModal(title: string, bodyText: string, body: TemplateRef<any>, action: (modal: NgbModalRef) => void) {
    this.editReasonText = "";
    this.editReasonBodyText = bodyText;
    const modalRef = this.modal.open(CustomDialogComponent);
    const modalComponent = modalRef.componentInstance as CustomDialogComponent;
    modalComponent.title = title;
    modalComponent.body =  body;
    modalComponent.buttons = [
      {
        label: "System.Cancel",
        class: "btn btn-text",
        disabled: () => false,
        action: (modal) => {
          modal.close();
        },
      },
      {
        label: "System.Save",
        class: "btn btn-primary",
        disabled: () => !this.editReasonText,
        action
      }
    ];
  }

  addJobJournal(textValue: string, from = "", to = "", typeId = "COMMENT") {
    this.job.journals.push({text: textValue, typeId, from, to, created: new Date(), by: this.appQuery.username, isNew: true});
  }

  // CHECKLIST RELATED
  getChecklistDto() {
    return () => this.checklistService.getJobChecklist(this.job.jobId);
  }

  updateChecklistResponse() {
    return (response: ChecklistEntryDto) => this.checklistService.updateResponse(this.job.jobId, response);
  }

  uploadFileToServer() {
    return (index: number, fileCap: FileCapture) => this.jobService.uploadAttachment(this.job.jobId, fileCap.file, fileCap.description, (prog) => null);
  }

  openDialog(component: TemplateRef<any>, buttons: ButtonType[], title: string): NgbModalRef {
    const modalRef = this.modal.open(CustomDialogComponent);
    const modalComponent = modalRef.componentInstance as CustomDialogComponent;
    modalComponent.title = title;
    modalComponent.body = component;
    modalComponent.buttons = buttons;
    return modalRef;
  }

  // SIGNATURE RELATED
  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;

  signaturePadOptions: NgSignaturePadOptions = { // passed through to szimek/signature_pad constructor
    minWidth: 200,
    canvasWidth: 200,
    canvasHeight: 200,
    backgroundColor: 'rgb(255,255,255)',
  };

  // @todo: set canvas size after inital render

  drawComplete(event: MouseEvent | Touch) {
    this.saveSignature();
  }

  drawStart(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onBegin event
    // console.log('Start drawing', event);
  }

  submitSignature($event) {
    // console.log('Submit Signature', $event);
  }

  clearSignature() {
    this.signaturePad.clear();
    this.currentHoldGroup.patchValue({signatureFile: null, signatureDataURL: "", text: ""});
    this.currentHoldGroup.markAsDirty();
  }

  saveSignature() {
    this.signaturePad.getCanvas().toBlob((blob) => {
      const sigFile = new File([blob], "signature.png", {type: "image/png"});
      // upload this file via attachment API
      this.currentHoldGroup.patchValue({signatureFile: sigFile, signatureDataURL: this.signaturePad.toData(), text: "Signature Captured for Customer"});
      this.currentHoldGroup.markAsDirty();
    });
  }

  @ViewChild("widthReferenceElement") widthRefElement;// used as sizing reference for Signature canvas
  // Ensures the Canvas data is retained on resize
  @HostListener('window:resize', ['$event'])
  resizeHandler(event: any) {
    if(!this.signaturePad) return;
    console.log('resize', event);
    const ratio = 1;
    // const ratio =  Math.max(window.devicePixelRatio || 1, 1);// doesnt match with HTML scaling factor
    const canvas = this.signaturePad.getCanvas();
    // get width from Notes field
    const notesWidth = (this.widthRefElement.nativeElement as HTMLTemplateElement).offsetWidth;
    // console.log("Job Loaded", notesWidth);
    // this.signaturePad.getCanvas().width = notesWidth;
    // canvas.width = (notesWidth * ratio) - 2;// compensate for border width
    // canvas.height = (canvas.offsetHeight * ratio) - 2;// compensate for border width
    this.signaturePad.set('minWidth', 5);
    this.signaturePad.set('canvasWidth', (notesWidth * ratio) - 2);
    this.signaturePad.set('canvasHeight', (canvas.offsetHeight * ratio) - 2);
    // console.log('resize', notesWidth, canvas.offsetWidth, canvas.offsetHeight);
    // console.log('resize', canvas.width, canvas.height);
    // canvas.getContext("2d").scale(ratio, ratio);
    this.signaturePad.fromData(this.signaturePad.toData());
    // this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  }

  setupSignatureValidations(holdIndex: number, validate: boolean = true) {
    const item = this.holds.at(holdIndex) as FormGroup;
    if(validate) {
      item.get("contactId").setValidators([Validators.required]);
      // item.get("gpscoordinates").setValidators([Validators.required]);
      item.get("signatureFile").setValidators([Validators.required]);
    } else {
      item.get("contactId").clearValidators();
      // item.get("gpscoordinates").clearValidators();
      item.get("signatureFile").clearValidators();
    }
    item.updateValueAndValidity();
  }

  customDialogComponent: CustomDialogComponent;
  currentHoldGroup: FormGroup;
  openSignatureDialog(holdIndex: number) {
    this.setupSignatureValidations(holdIndex);
    this.currentHoldGroup = this.holds.at(holdIndex) as FormGroup;
    if(this.currentHoldGroup.get("contactId").value === "") {
      this.currentHoldGroup.patchValue({contactId: this.job.contact.contactId});
    }

    const title = "Signature for Customer";
    // this.editReasonBodyText = bodyText;
    const modalRef = this.modal.open(CustomDialogComponent);
    this.customDialogComponent = modalRef.componentInstance as CustomDialogComponent;
    this.customDialogComponent.title = title;
    this.customDialogComponent.body =  this.signatureDialogBody;
    this.customDialogComponent.buttons = [
      {
        label: "System.Cancel",
        class: "btn btn-text",
        disabled: () => false,
        action: (modal) => {
          if(this.currentHoldGroup.dirty) {
            // this.currentHoldGroup.patchValue({ contactId: "", signatureFile: null, text: "", gpscoordinates: null });
          }
          modal.close();
          this.setupSignatureValidations(holdIndex, false);
        },
      },
      {
        label: "System.Save",
        class: "btn btn-primary",
        disabled: () => {
          console.log('checking save', this.currentHoldGroup.invalid);
          return this.currentHoldGroup.invalid;
        },
        action: (mod) => {
          if(this.currentHoldGroup.dirty) {
            // Process Signature Upload
            this.customDialogComponent.showSpinner = true;
            this.uploadSignatureForHoldGroup(this.currentHoldGroup).then((att) => {
              this.currentHoldGroup.patchValue({ attachmentId: att.attachmentId, status: JobHoldTypes.ACCEPTED});
              this.customDialogComponent.showSpinner = false;
              mod.close();
            });
          }
        }
      }
    ];

    checkUntilExists(() => !!this.widthRefElement, () => {
      this.resizeHandler(null);
      if(this.currentHoldGroup.get("signatureDataURL").value) {
        setTimeout(() => {
          this.signaturePad.fromData((this.currentHoldGroup.get("signatureDataURL").value));
        }, 100);
      }
    });
  }

  backofficeApprove(holdIndex: number) {
    const holdGroup = this.holds.at(holdIndex) as FormGroup;
    this.setupSignatureValidations(holdIndex, false);
    holdGroup.patchValue({status: JobHoldTypes.ACCEPTED});
    this.form.markAsDirty();
  }

  uploadSignatureForHoldGroup(holdGroup: FormGroup): Promise<BaseAttachmentDto> {
    const fileDescription = "Signature for " + fullName(this.customer.contacts.find(c => c.contactId === holdGroup.get("contactId").value)) || "Customer";
    return this.jobService.uploadAttachment(
      this.job.jobId,
      holdGroup.get("signatureFile").value,//actual File Object
      fileDescription,
      (prog) => null,
      false,
      null,
      AttachmentType.SIGNATURE
    )
    .toPromise();
  }

  // TODO: flesh this out
  openContactDialog() {
    const modal = this.dialog.open(ContactComponent, {data: newCustomerContact()});
    modal.afterClosed().subscribe(data => {
      if (data) {
        this.customerService.addContact(this.job.customerId, data).subscribe(contact => {
          this.currentHoldGroup.patchValue({contactId: contact.contactId});
          // Refresh Customer Data
          this.customerService.getCustomer(this.job.customerId).pipe(take(1)).subscribe(val => this.customer = val);
        });
      }
    });
  }

  holdPermission(hold: JobHoldDto, permission: string) {
    const holdRef = this.holdTypes.item(hold.typeId);
    return holdRef?.permissions?.[permission] || false;
  }

  openViewerById(attachmentId: string) {
    const jobAtt = this.job.attachments.find(a => a.attachmentId === attachmentId);
    if(jobAtt) {
      const payload: AttachmentGalleryData = {
        attachments: [jobAtt],
        service: this.jobService,
        parentId: this.job.jobId,
      };
      this.pubSub.publish("attachment_viewer", payload);
    }
  }

  onlyAdhocHolds = false;
  /**
   * When only Adhoc Holds are to be shown we use the Hold.order to filter
   */
  holdsFilterFunc() {
    return (hold: LookupObjectDto) => {
      return this.onlyAdhocHolds ? hold.order < 100 : true;
    };
  }

  printSections: string[] = [];
  selectedPrintOption: string = 'Default';
  beforePrint(event, printOption: string = 'Default') {
    this.selectedPrintOption = printOption;
    this.printSections = this.printOptionSections[printOption];
    setTimeout(() => {
      window.print();
    }, 100);
  }
}
